import React, { useState } from 'react';
import { Form, FormGroup, Label, Input } from 'reactstrap';

import { Modal, Header, Body, Footer, FooterButton } from './modalElements';
import { InfoText } from '../../user/components';
import { FeedbackModalBody, LabelHeading } from './styles';

export default React.memo(({ modalInfo, confirm }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [message, setMessage] = useState('');
  const [hasValidationError, setHasValidationError] = useState(false);

  const hideModal = () => {
    setIsOpen(false);
    return confirm({
      isSubmitted: false,
    });
  };

  const submitForm = (e) => {
    e.preventDefault();
    if (!message) return setHasValidationError(true);
    setHasValidationError(false);
    setIsOpen(false);
    return confirm({
      message: message,
      isSubmitted: true,
      isRejected: modalInfo.isRejected,
      _id: modalInfo._id,
    });
  };

  return (
    <Modal isOpen={isOpen}>
      <Header>{modalInfo.title}</Header>
      <Form onSubmit={(e) => submitForm(e)}>
        <Body>
          <FeedbackModalBody>
            <FormGroup>
              <Label>
                <LabelHeading>Test name:</LabelHeading> {modalInfo.test}
              </Label>
              <Label dangerouslySetInnerHTML={{ __html: modalInfo.question }}></Label>
              <Label>Please enter the reason for {modalInfo.isRejected ? 'rejecting' : 'updating'} this feedback</Label>
              <Input
                type="textarea"
                name="text"
                rows="4"
                onChange={(e) => setMessage(e.target.value)}
                placeholder={`Enter reason for ${modalInfo.isRejected ? 'rejecting' : 'updating'}`}
              />
              {hasValidationError && <InfoText error="true">Please provide a reason</InfoText>}
            </FormGroup>
          </FeedbackModalBody>
        </Body>
        <Footer>
          <FooterButton label="Submit" />
          <FooterButton label="Close" onClick={() => hideModal(false)} />
        </Footer>
      </Form>
    </Modal>
  );
});
